import styled from 'styled-components';

const Skillset = styled.section`
    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: space-evenly;
    align-items: center;

    background-color: #374045;
`

export { Skillset };